const PROJECT_BY_ENDPOINT = {
  production: 'tern-1d723',
  staging: 'tern-staging',
  testing: 'tern-app-testing',
};

const getRuntimeEndpoint = () => {
  if (typeof window !== 'undefined') {
    const host = window.location.hostname;

    if (host.startsWith('staging.') || host.includes('tern-staging')) {
      return 'staging';
    }

    if (
      host.includes('tern-web-testing') ||
      host.includes('tern-app-testing')
    ) {
      return 'testing';
    }

    if (
      host === 'heytilly.ai' ||
      host === 'www.heytilly.ai' ||
      host.includes('tern-1d723')
    ) {
      return 'production';
    }
  }

  return process.env.VUE_APP_ENDPOINTS;
};

export const getTernApiProject = () =>
  PROJECT_BY_ENDPOINT[getRuntimeEndpoint()] || PROJECT_BY_ENDPOINT.testing;

export const getTernApiBase = () =>
  `https://us-central1-${getTernApiProject()}.cloudfunctions.net/ternAPI/v1`;
